import React from 'react';
import CommonModal from "components/App/commonModal"
import QRCode from "qrcode.react";
import { Context,Hooks,Util,Request } from "@xt/xtbase";
import { Table, Space } from "antd";
import logo from "assets/images/home/logo2.png";
import { useIntl, FormattedMessage } from "react-intl";

const {useTranslation, useDocumentWidth} = Hooks;
const {getOrigin, getUrl} = Util;

function InviteCodeModal(props) {
  const t = useTranslation();
  const domeWidth = (useDocumentWidth() ?? 0) > 768
  const {qrUrl, isShowModal, onClose, inviteeCommissionRate, inviteCode, codeTitle} = props;

  const renderTitle = () => {
    return (
      <div className="titlePng" style={{ backgroundImage: `url(${logo})` }}></div>
    )
  }

  return (
    <>
      <CommonModal width={domeWidth ? 480 : 311} title={renderTitle()} isShowModal={isShowModal} onClose={onClose}>
        <div className="InviteCodeModal">
          <div className='codeTitle'>
            {inviteeCommissionRate && <FormattedMessage
              id="home.qrCodeTip"
            />}
            {codeTitle && <div>{codeTitle}</div>}
          </div>
          <div className='code'>
            <QRCode
              value={qrUrl} //value参数为生成二维码的链接
              size={domeWidth ? 380 : 252} //二维码的宽高尺寸
              fgColor="#000000" //二维码的颜色
            />
          </div>
          {domeWidth && inviteCode && <div className='inviteCodeTitle'>
            {t("home.invitationCode")}
          </div>}
          {domeWidth && inviteCode && <div className='inviteCode'>
            {inviteCode}
          </div>}
        </div>
      </CommonModal>
    </>
  );
}

export default InviteCodeModal;
